module.exports = __webpack_public_path__ + "img/doorLogo29.1796a1f3.png";